import React from 'react';
import { useSelector } from 'react-redux';
import { getStudentLoanBalance, getStudentLoanData } from 'selectors/getStudentLoanData';
import FormContainer from 'components/LoanForm/FormContainer';
import { formatMonetaryAmount } from 'utils/formatMonetaryAmount';
import { ReactComponent as StudentLoanIcon } from 'images/student-loan.svg';

interface QuestionsWrapperProps {
  title: string;
  subtitle?: string | JSX.Element;
  showBalance?: boolean;
  children: JSX.Element;
}

const QuestionsWrapper = ({ title, subtitle, showBalance = false, children }: QuestionsWrapperProps) => {
  const balance = getStudentLoanBalance(useSelector(getStudentLoanData));

  return (
    <FormContainer
      icon={<StudentLoanIcon />}
      title={title}
      subtitle={
        showBalance && balance ? (
          <p>
            We found <strong>{formatMonetaryAmount(balance)}</strong> in federal student loans on your credit report.
          </p>
        ) : (
          subtitle
        )
      }
    >
      {children}
    </FormContainer>
  );
};

export default QuestionsWrapper;
